/**
 * set key/value in sessionStorage
 * @param key
 * @param value
 */
export const setSessionStorage = (key: string, value: string) => {
  if (typeof sessionStorage !== 'undefined' && key && value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {
      console.error('Failed to set sessionStorage:', err);

      if (process.env.ENABLE_UTM_DEBUG_LOGGING === 'true') {
        fetch(`${origin}/api/utm-debug-log/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            origin,
            key,
            value,
            source: 'sessionStorage',
            status: 'error'
          })
        }).catch((err) => {
          console.error('Failed to set sessionStorage:', err);
        });
      }
    }
  }
};

/**
 * retrieve value by key from sessionStorage
 * @param key
 * @returns
 */
export const getSessionStorage = (key: string) => {
  try {
    const item =
      typeof sessionStorage !== 'undefined'
        ? sessionStorage.getItem(key)
        : null;

    if (!item) {
      return null;
    }

    try {
      return JSON.parse(item);
    } catch {
      return item;
    }
  } catch (err) {
    console.error('Failed to get sessionStorage:', err);

    if (process.env.ENABLE_UTM_DEBUG_LOGGING === 'true') {
      fetch(`${origin}/api/utm-debug-log/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          origin,
          key,
          source: 'sessionStorage',
          status: 'error'
        })
      }).catch((err) => {
        console.error('Failed to get sessionStorage:', err);
      });
    }
  }
};

/**
 * retrieve key/value from sessionStorage
 * @param key
 */
export const removeSessionStorage = (key: string) => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(key);
  }
};
